import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const opportunityTypeService = createApi({
    reducerPath: 'opportunityTypeService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['OpportunityType'],
    endpoints: (builder) => ({

        getAllOpportunityType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.getAllOpportunityType}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        getOpportunityTypeById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.getOpportunityTypeById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        saveOpportunityType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.saveOpportunityType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        updateOpportunityType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.updateOpportunityType}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        deleteOpportunityType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.deleteOpportunityType}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        getAllOpportunityTypeBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.getAllOpportunityTypeBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        findAllOpportunityType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.findAllOpportunityType}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),
        bulkSaveOpportunityType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityTypeController.bulkSaveOpportunityType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    }),
});

export const {
    useGetAllOpportunityTypeMutation,
    useGetOpportunityTypeByIdMutation,
    useSaveOpportunityTypeMutation,
    useUpdateOpportunityTypeMutation,
    useDeleteOpportunityTypeMutation,
    useGetAllOpportunityTypeBySearchMutation,
    useFindAllOpportunityTypeMutation,
    useBulkSaveOpportunityTypeMutation
} = opportunityTypeService;
